import { List, ListItem, Typography, Box, Stack } from '@mui/material'
import { getBenefitDiscount, sortBenefits } from './helper'
import { Types } from 'service-api'
import { generateBenefitDisplayName } from '@shared/memberships'
import { i18WithDefault as t } from '@shared/locales'

type BenefitsListProps = {
  benefits: Types.BenefitAdminDto[] | Types.BenefitClientDto[]
  layout?: 'default' | 'columns'
}

export const BenefitsList = ({ benefits, layout = 'default' }: BenefitsListProps) => {
  const sortedBenefits = sortBenefits(benefits)

  if (layout === 'default') {
    return (
      <List sx={{ pl: 4 }}>
        {sortedBenefits.map((benefit) => (
          <ListItem key={benefit.id} disablePadding sx={{ display: 'list-item', listStyle: 'disc', mb: 0.5 }}>
            <Typography component="span" variant="body1bold">
              {benefit.qty ? `${benefit.qty}x ` : `${t('membership.benefit.unlimited')} - `}
            </Typography>
            <Typography component="span" variant="body1bold">{`${getBenefitDiscount(benefit)} ${t(
              'membership.benefit.discount'
            )} `}</Typography>
            <Typography component="span">{generateBenefitDisplayName(benefit)}</Typography>
          </ListItem>
        ))}
      </List>
    )
  }

  const columns: Types.BenefitAdminDto[][] | Types.BenefitClientDto[][] = []
  for (let i = 0; i < sortedBenefits.length; i += 4) {
    columns.push(sortedBenefits.slice(i, Math.min(i + 4, sortedBenefits.length)))
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      {columns.map((column, colIndex) => (
        <Box
          key={`column-${colIndex}`}
          sx={{
            flex: '1 1 50%',
            maxWidth: '100%',
            '@media (min-width: 600px)': { maxWidth: 'calc(50% - 8px)' },
          }}
        >
          <Stack>
            {column.map((benefit) => (
              <List key={benefit.id} sx={{ pl: 4, m: 0 }} disablePadding>
                <ListItem disablePadding sx={{ display: 'list-item', listStyle: 'disc', mb: 0.5 }}>
                  <Typography component="span" variant="body1bold">
                    {benefit.qty ? `${benefit.qty}x ` : `${t('membership.benefit.unlimited')} - `}
                  </Typography>
                  <Typography component="span" variant="body1bold">{`${getBenefitDiscount(benefit)} ${t(
                    'membership.benefit.discount'
                  )} `}</Typography>
                  <Typography component="span">{generateBenefitDisplayName(benefit)}</Typography>
                </ListItem>
              </List>
            ))}
          </Stack>
        </Box>
      ))}
    </Box>
  )
}
